import React from 'react'
import PropTypes from 'prop-types'

export const ActiveShipments = React.memo(({ count }) => {
  const activeShipmentCount = count - 1
  const activeMessage = `other active shipment${
    activeShipmentCount > 1 ? 's are' : ' is'
  } being hauled by this carrier.`
  return (
    <>
      <p>
        {activeShipmentCount} {activeMessage}
      </p>
    </>
  )
})

ActiveShipments.propTypes = {
  count: PropTypes.number,
}
ActiveShipments.defaultProps = {
  count: 0,
}
